<!--聊天交流  -->
<template>
  <div class=chat>
    <!-- 聊天列表 -->
    <div class="chat-box">
      <ul v-if="selected===0">
        <li  v-for="(item, index) in allMsgList" :key="index" v-show="currentTimeStamp > item.time">
          <template v-if="currentTimeStamp > item.time">
            <span :class="item.type">{{ setName(item) }}：</span><b class="txt" v-html="item.content"></b>
          </template>
        </li>
      </ul>
      <ul v-else>
         <li  v-for="(item, index) in officialList" :key="index" v-show="currentTimeStamp > item.time">
          <template v-if="currentTimeStamp > item.time">
            <span :class="item.type">{{ setName(item) }}：</span>
            <b class="txt" v-html="item.content"></b>
          </template>
        </li>
      </ul>
      <div :class="['goBottom',isFullScreen ? 'fullGoBottom' : '']" v-show="btnShow" @click="goToBottom">
        <img src="../../../assets/img/live/downarrow.png" alt="">
        <span>点击到底部</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      allMsgList: [], // 所有聊天信息
      officialList: [], // 官方聊天列表
      onlyLook: false, // 仅看官方
    };
  },
  props: {
    selected: {
      type: Number,
      default: 0,
    },
    isFullScreen: {
      type: Boolean,
      dafault: false,
    },
    chatList: {
      type: Array,
      dafault: [],
    },
    skuId: {
      type: Number,
      default: 0,
    },
    currentTimeStamp: {
      type: Number,
      default: 0,
    },
    isCommentGroup: { // 是否开启分组
      type: Number,
      default: 0,
    },
  },
  watch: {
    chatList() {
      this.detailChat();
    },
  },
  /* eslint-disable */
  computed: {
    btnShow() {
      if(this.selected === 0) {
        return this.allMsgList.filter(item => item.time < this.currentTimeStamp).length >= 6
      } else {
        return this.officialList.filter(item => item.time < this.currentTimeStamp).length >= 6
      }
    },
  },
  mounted() {},
  methods: {
    goToBottom() {
      $('.tab-content').scrollTop($('.chat').height());
    },
    detailChat() {
      this.chatList.forEach((t) => {
        if (this.isCommentGroup === 0 || t.groupId == this.skuId || !t.groupId) {
          if (t.isFilterChat && t.isFilterChat === 1) return;
          this.allMsgList.push({
            type: t.userRole,
            name: t.username,
            content: this.changeEmImg(t),
            time: t.time,
          });
          if (t.userRole === 'host' || t.userRole === 'teacher' || t.userRole === 'publisher') {
            this.officialList.push({
              type: t.userRole,
              name: t.username,
              content: this.changeEmImg(t),
              time: t.time,
            });
          }
        }
      });
    },

    // 设置发言人名称
    setName(item) {
      // host:主持人 teacher:助教 publisher:讲师
      let { name } = item;
      if (item.type === 'publisher') {
        name = '讲师';
      } else if (item.type === 'teacher') {
        name = '助教';
      } else if (item.type === 'host') {
        name = '主持人';
      } else if (/^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(name)) {
        name = `${name.substr(0, 3)}****${name.substr(7)}`;
      }
      return name;
    },
    // 聊天内容处理
    changeEmImg(t) {
      let msg = ''; let
        str = t.msg;
      if (str.indexOf('[img_') > -1) {
        // 图片处理
        const url = str.split('[img_')[1].replace(']', '');
        let w = '300px';
        let h;
        if (url.indexOf('w=') > -1) w = url.split('w=')[1].split('&h=')[0];
        if (url.indexOf('h=') > -1) h = url.split('h=')[1];
        const winW = window.innerWidth;
        if (w >= winW) {
          w = '100%';
        } else {
          w = `${(w / winW) * 100}%`;
        }
        msg = `<img src=${url} style="width: ${w}; height: ${h}; vertical-align: middle"/>`;
      } else {
        str = str.replace(/\</g, '&lt;');
        str = str.replace(/\>/g, '&gt;');
        str = str.replace(/\n/g, '<br/>');
        str = str.replace(
          /\[em_([0-9]*)\]/g,
          '<img src="http://view.csslcloud.net/img/em/$1.gif" width="16" height="16" style="vertical-align: middle; transform: translateY(-2px);margin-left: 2px"/>',
        );
        str = str.replace(
          /\[em2_([0-9]*)\]/g,
          '<img src="http://view.csslcloud.net/img/em2/$1.png" width="16" height="16" style="vertical-align: middle; transform: translateY(-2px);margin-left: 2px"/>',
        );
        $.each(str.split(' '), (i, n) => {
          n = $.trim(n);
          if (n.indexOf('[uri_') == 0 && n.indexOf(']') == n.length - 1 && n.length > 6) {
            const u = `${n.substring(5, n.length - 1)} `;
            msg += `<a target="_blank" style="color: #0091FF" href="${u}">${u}</a>` + ' ';
          } else if (t.userRole === 'student') {
            msg += `${n} `;
          } else {
            msg += `${this.ReplaceUrl(n)} `;
          }
        });
      }
      return msg;
    },
    ReplaceUrl(text) {
      const re = /(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[\w-\.\/\?%&=]*)?)/gi;
      const s = text.replace(re, (u) => `<a target="_blank" style="color: #0091FF" href="${u}" target=_blank>${u}</a>`);
      return s;
    },
  },
};
/* eslint-enable */
</script>
<style lang="scss" scoped>

.chat-box {
  width: 100%;
  padding-bottom: 170px;
  ul {
    width: 100%;
    padding: 24px 40px;
    li {
      padding-bottom: 24px;
      .host {
        color: #337ade;
        font-size: 28px;
      }
      .publisher {
        color: #3eccc7;
        font-size: 28px;
      }
      .teacher {
        color: #ffad1e;
        font-size: 28px;
      }
      .student {
        color: #787878;
        font-size: 28px;
      }
      .txt {
        color: #787878;
        font-weight: normal;
        font-size: 28px;
        word-break: break-all;
      }
    }
  }
  .goBottom {
    position: fixed;
    bottom: 15%;
    left: 50%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 179px;
    height: 43px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 22px;
    transform: translateX(-50%);
    img {
      width: 16px;
      height: 20px;
    }
    span {
      color: #fff;
      font-size: 22px;
    }
  }
  .fullGoBottom {
    right: 5%;
    bottom: 17%;
    left: initial;
    transform: initial;
  }
}

</style>
